
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/integrations",
      function () {
        return require("private-next-pages/site/integrations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/integrations"])
      });
    }
  